import {FC} from "react";
import {Link} from "../../../ui";
import styled from "styled-components";
import useDrawer from "../../../hooks/useDrawer";
import Loading from "../../../ui/Loading/Loading";
import {LoadingIcon} from "../../../ui/Icons";
import {useAppSelector} from "../../../hooks/useAppDispatch";
import {useGetAccessoriesByIdQuery} from "./__generated__/AccessoriesRoot.query.generated";
import AccessoriesInform from "../AccessoriesInform/AccessoriesInform";

const Options = styled.div`
  h2 {
    font-weight: 400;
    color: ${props => props.theme.palette.purple};
  }
  ul {
    display: flex;
    flex-direction: column;
  }
`;

const AccessoriesRoot:FC = () => {
  const { openChildrenHandler } = useDrawer();
  const { id } = useAppSelector(state => state.drawer);
  const { data, loading, error } = useGetAccessoriesByIdQuery({ variables: { id }});

  if (loading || !data) {
    return (
      <Loading><LoadingIcon /></Loading>
    );
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  if (!data?.getAccessoriesById) {
    return <p>Возможно произошла ошибка или ID был пуст</p>;
  }

  return (
    <>
      <AccessoriesInform
        info={data.getAccessoriesById}
      />
      <Options>
        <h2>Управление акссесуаром</h2>
        <ul>
          <Link onClick={() => openChildrenHandler('accessoriesSettingsEdit')}>Редактировать акссесуар</Link>
          <Link onClick={() => openChildrenHandler('accessoriesSettingsDelete')}>Удалить акссесуар</Link>
        </ul>
      </Options>
    </>
  )
}

export default AccessoriesRoot;
